import React from "react";
import UserDataForm from "./UserDataForm";
import {Link} from 'react-router-dom';

class AddUserForm extends React.Component {

    createUser = e => {
        e.preventDefault();


        const form = e.target;

        const userData = {
            firstname: form.firstname.value,
            lastname: form.lastname.value,
            email: form.email.value,
        };

        this.props.addUser(userData, e.target)

    };

    checkMe = e => {

        const el      = e.currentTarget;
        const prevSib = el.previousSibling;

        console.log('is valid:', el.checkValidity());

        if (prevSib && el.checkValidity()) {
            prevSib.classList.add('valid');
        } else if (prevSib) {
            prevSib.classList.remove('valid');
        }

    }

    componentDidMount() {
        console.log(this.constructor.name);
    }


    render() {
        return (
            <form id="addUserData" className="fish-edit" onSubmit={this.createUser}>
                <UserDataForm checkme={this.checkMe}/>

                <div className="btn-wrp submit-button">
                    <button type="submit">Create new profile</button>
                </div>
                <div className="btn-wrp">
                    <Link to="/edit">Edit existing profile</Link>
                </div>

            </form>
        );
    }
}

export default AddUserForm;
